// Thin re-export. Source of truth lives in @washday/utilities.
// Keeping this module so existing imports across the app keep working.
export {
  getPiecesBreakdown,
  formatPiecesBreakdown,
  getMeasuredUnitLabel,
  type PiecesBreakdown,
  type FormatPiecesBreakdownOptions,
  type MeasurementUnitsOption as IMeasurementUnitsOption
} from '@washday/utilities';

import { getPiecesBreakdown } from '@washday/utilities';

/**
 * Returns total count of "normal" pieces only (excludes weight/length).
 * Kept for compatibility; use getPiecesBreakdown + formatPiecesBreakdown for display.
 */
export const getAllPieces = (
  products: Array<{ type?: string; pieces?: number; quantity?: number } | string> | undefined,
  buyAndGetProducts: Array<{ type?: string; pieces?: number; quantity?: number } | string> | undefined
): number => {
  const { pieces } = getPiecesBreakdown(products as any, buyAndGetProducts as any);
  return pieces;
};
